// Router minimo basado en hash (#/ruta).

export type Pagina = (contenedor: HTMLElement) => void | Promise<void>;

export interface Ruta {
  hash: string;
  titulo: string;
  render: Pagina;
  oculta?: boolean;
  // Modulo requerido para ver la ruta ('__admin' = solo administrador).
  permiso?: string;
}

export function navegar(hash: string): void {
  if (location.hash === hash) render();
  else location.hash = hash;
}

let rutas: Ruta[] = [];
let contenedor: HTMLElement;

function render(): void {
  const hash = location.hash || rutas[0]?.hash || "#/";
  const ruta = rutas.find((r) => r.hash === hash) ?? rutas[0];
  if (ruta && contenedor) {
    contenedor.innerHTML = "";
    void ruta.render(contenedor);
  }
}

export function iniciarRouter(_rutas: Ruta[], _contenedor: HTMLElement): void {
  rutas = _rutas;
  contenedor = _contenedor;
  window.addEventListener("hashchange", render);
  render();
}
